module.exports = __webpack_public_path__ + "static/media/jet.1e39d10b.png";